module.exports = __webpack_public_path__ + "img/04.9174d5d6.jpg";